import { all, fork } from 'redux-saga/effects';

import listenAuthoriseSecurityDeposit from './listenAuthoriseSecurityDeposit';

export default function* bookingCardSaga() {
  yield all([fork(listenAuthoriseSecurityDeposit)]);
}
